import { render, staticRenderFns } from "./himbauan_biasa.vue?vue&type=template&id=35c7586c&"
import script from "./himbauan_biasa.vue?vue&type=script&lang=js&"
export * from "./himbauan_biasa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports